///NOT USING THE REACT BOOTSTRAP TABLE

import React from 'react';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';

class DataTable extends React.Component {

    renderTableContent = (keyValues) => {
        var i = 0;
        return keyValues.map(keyValue => {
          return (
            <TableHeaderColumn key={i++}   dataField={keyValue} dataSort>{keyValue}</TableHeaderColumn>
          )
        })
      }


    render() {
        const keyValues = Object.keys(this.props.data[0]);
        return (
            <div className="data-table">
                <BootstrapTable data={this.props.data} keyField={keyValues[0]} striped hover>
                    {this.renderTableContent(keyValues)}
                </BootstrapTable>
            </div>
        )
    }
}
export default DataTable;






// WEBPACK FOOTER //
// ./src/app/common/DataTable.js